import { render, staticRenderFns } from "./ImportResults.vue?vue&type=template&id=9ca5b436&scoped=true"
import script from "./ImportResults.vue?vue&type=script&lang=js"
export * from "./ImportResults.vue?vue&type=script&lang=js"
import style0 from "./ImportResults.vue?vue&type=style&index=0&id=9ca5b436&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca5b436",
  null
  
)

export default component.exports